const STANDARD_SOURCES = [
  "ELECTRICITYPLANS",
  "POWERTOCHOOSE",
  "SAVEONENERGY",
  "COMPAREPOWER",
  "TEXAS ELECTRICITY RATINGS",
  "ENERGYBOT",
];

export const normalizeSourceLabel = (source: string): string => {
  const upper = (source || "").toUpperCase();
  if (STANDARD_SOURCES.includes(upper)) {
    return upper;
  }
  return "Retail Energy Providers";
};

export const matchesTermFilter = (
  item: any,
  selectedTerms: string[],
  termField = "term"
): boolean => {
  if (!selectedTerms.length) return true;
  const itemTerm = Number(item[termField]);
  return selectedTerms.some((term) => itemTerm === Number(term));
};

export const matchesSourceFilter = (
  item: any,
  selectedSources: string[]
): boolean => {
  if (!selectedSources.length) return true;
  const itemSource = normalizeSourceLabel(String(item.source || ""));
  return selectedSources.some(
    (source) => itemSource.toLowerCase() === source.toLowerCase()
  );
};

export const extractUniqueTerms = (
  data: any[],
  termField = "term"
): string[] => {
  const terms = data
    .map((item) => String(item[termField] ?? "").trim())
    .filter(Boolean);
  return [...new Set(terms)].sort((a, b) => Number(a) - Number(b));
};

export const extractUniqueSources = (
  data: any[]
): string[] => {
  const sources = data.map((item) =>
    normalizeSourceLabel(String(item.source || ""))
  );
  return [...new Set(sources)];
};

export const toggleMultiSelectValue = (
  selected: string[],
  value: string
): string[] => {
  if (selected.includes(value)) {
    return selected.filter((item) => item !== value);
  }
  return [...selected, value];
};
